import { ReactComponent as FlagIcon } from "./svg/ru-flag.svg";
import "../flag-icon.scss";

export const RUFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
